import { Navigate, Route } from 'react-router-dom';
import TermsOfService from '../../pages/termsofservice';
import PrivacyPolicy from '../../pages/privacypolicy';
import { Onboarding } from '../../pages/OnBoarding';
import AuthPage from '../../pages/Auth/index';
import {
  SignupForm,
  VerifyEmail,
  LoginForm,
} from '../../pages/Auth/components';
import AuthImage from '../../assets/images/auth/signup1.png';

/**
 * Public (unauthenticated) route definitions -- rendered as the children of
 * <Route element={<PublicRoutes />}> in App.tsx. Exported as a Fragment of
 * <Route> elements: React Router's route-config builder recurses into
 * Fragment children the same way it does direct <Routes> children, so this
 * can be spread in as {PublicRouteElements} without losing route matching.
 */
const PublicRouteElements = (
  <>
    <Route path='/' element={<Navigate to='/login' replace />} />
    <Route path='/terms-of-service' index element={<TermsOfService />} />
    <Route path='/privacy-policy' index element={<PrivacyPolicy />} />
    <Route path='/' element={<Navigate to='/login' />} />
    <Route
      path='/verify-email'
      element={
        <Onboarding>
          <VerifyEmail />
        </Onboarding>
      }
    />
    <Route
      path='/signup'
      element={
        <AuthPage
          title='You’re on your way to protecting all your critical shipments.'
          description='Start setting up your Zoomlogi account and you’ll be one step closer to preventing waste, reducing inefficiencies, and improving patient outcomes.'
          imageSrc={AuthImage}
          imageOnLeft={false}
          pageName='Signup'
        >
          <SignupForm />
        </AuthPage>
      }
    />
    <Route
      path='/login'
      element={
        <AuthPage
          title='You’re on your way to protecting all your critical shipments.'
          description='Start setting up your Zoomlogi account and you’ll be one step closer to preventing waste, reducing inefficiencies, and improving patient outcomes.'
          imageSrc={AuthImage}
          imageOnLeft={false}
          pageName='Login'
        >
          <LoginForm />
        </AuthPage>
      }
    />
  </>
);

export default PublicRouteElements;
